import { isNumber } from 'lodash';

export function numSeparator(value = '', separator = ',') {
  return value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, separator);
}

export function numSeparatorRound(value = '', separator = ',') {
  return Math.round(value)
    .toString()
    .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, separator);
}

export function formatNumberRound(value = '') {
  return formatNumber(Math.round(value));
}

export const isValidNumber = (value) => {
  const number = parseFloat(value);
  if (isNumber(number) && number.toString() === value) {
    return true;
  } else if (value.endsWith('.') || value.startsWith('.') || value === '.') {
    return true;
  }
  return false;
};

export const validateInput = (input) => {
  let isValid = false;
  if (isValidNumber(input.value)) {
    input.setCustomValidity('');
    isValid = true;
  } else {
    input.setCustomValidity('Please enter a number');
  }

  input.reportValidity();
  return isValid;
};

function countDecimalPlaces(num) {
  const numStr = num.toString();
  // Handle scientific notation
  if (numStr.includes('e') || numStr.includes('E')) {
    const decimalPlaces = num.toFixed(20).split('.')[1].replace(/0+$/, '').length;
    return decimalPlaces;
  }
  // Handle decimal numbers
  if (numStr.includes('.')) {
    return numStr.split('.')[1].length;
  }
  return 0;
}

function formatWithSeparators(num, locale = 'en-US') {
  if (isStringNumber(num)) {
    num = parseFloat(num);
  }

  if (typeof num !== 'number' || isNaN(num)) {
    console.log('Input must be a valid number.', num);
    return num;
  }

  const decimalPlaces = countDecimalPlaces(num);

  return num.toLocaleString(locale, {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
    useGrouping: true,
  });
}

function isStringNumber(value) {
  if (typeof value === 'string' && !isNaN(value) && value.trim() !== '') {
    return true;
  }
  return false;
}

export function formatNumber(num, locale = 'en-US') {
  if (isStringNumber(num)) {
    num = parseFloat(num);
  }

  if (typeof num !== 'number' || isNaN(num) || !isFinite(num)) {
    console.log('Input must be a valid number. to be able to format it', num);
    return num;
  }

  const sign = num < 0 ? '-' : '';
  const absNum = Math.abs(num);

  if (absNum < 100000) {
    return formatWithSeparators(num, locale);
  }

  const units = [
    { value: 1e12, suffix: 'T' }, // Trillion
    { value: 1e9, suffix: 'B' }, // Billion
    { value: 1e6, suffix: 'M' }, // Million
    { value: 1e3, suffix: 'K' }, // Thousand
  ];

  for (let i = 0; i < units.length; i++) {
    if (absNum >= units[i].value) {
      let numUnits = absNum / units[i].value;

      // Check if rounding will push the number into the next unit
      if (numUnits >= 999.995 && i > 0) {
        numUnits = absNum / units[i - 1].value;
        const formattedNum = parseFloat(numUnits.toFixed(2));

        return (
          sign +
          formattedNum.toLocaleString(locale).replace(/(\.[0]+|\.00)$/, '') +
          units[i - 1].suffix
        );
      } else {
        const formattedNum = parseFloat(numUnits.toFixed(2));

        return (
          sign + formattedNum.toLocaleString(locale).replace(/(\.[0]+|\.00)$/, '') + units[i].suffix
        );
      }
    }
  }

  // Fallback for numbers smaller than the smallest unit
  return formatWithSeparators(num, locale);
}

export function formatTime(seconds) {
  const s = parseInt(seconds);

  if (s < 0) return s; // Return negative values as is

  if (s < 120) {
    return `${s}s`; // Show seconds for values below 120
  } else if (s < 3600) {
    const minutes = (s / 60).toFixed(2);
    return `${minutes}m`; // Convert to minutes for values between 120 and 3600
  } else if (s < 86400) {
    const hours = (s / 3600).toFixed(2);
    return `${hours}h`; // Convert to hours for values between 3600 and 86400
  } else {
    const days = (s / 86400).toFixed(2);
    return `${days}d`; // Convert to days for values above 86400
  }
}
